export enum AdmissionGroupPlatformType {
  TABLELIST_APP = 'TABLELIST_APP',
  TABLELIST_WIDGET = 'TABLELIST_WIDGET',
  WEBSITE_WIDGET = 'WEBSITE_WIDGET',
}

export enum AdmissionGroupEmailAddresses {
  EMAIL_REPLY_TO_NONE = 'no-reply@tablelistpro.com',
  EMAIL_REPLY_TO_TABLELIST = 'hello@tablelist.com',
}

export enum AdmissionGroupCancelledReason {
  FRAUD = 'FRAUD',
  VENUE = 'VENUE',
  NO_SHOW = 'NO_SHOW',
  DUPLICATE = 'DUPLICATE',
  MISTAKE = 'MISTAKE',
  USER = 'USER',
  INQUIRY_DECLINED = 'INQUIRY_DECLINED',
}

export enum AdmissionGroupCancelledReasonName {
  FRAUD = 'Fraud',
  VENUE = 'Venue Canceled',
  NO_SHOW = 'No Show',
  DUPLICATE = 'Duplicate',
  MISTAKE = 'Mistake',
  USER = 'Guest Canceled',
  INQUIRY_DECLINED = 'Inquiry Declined',
}

export enum AdmissionGroupCreatedBy {
  MEMBER = 'MEMBER',
  RELATIONSHIP = 'RELATIONSHIP',
  TABLELIST = 'TABLELIST',
  TABLELIST_WIDGET = 'TABLELIST_WIDGET',
  WEBSITE_WIDGET = 'WEBSITE_WIDGET',
  IMPORT = 'IMPORT',
}

export enum AdmissionGroupCreatedByName {
  MEMBER = 'Staff Member',
  RELATIONSHIP = 'Promoter',
  TABLELIST = 'Tablelist',
  TABLELIST_WIDGET = 'Tablelist Widget',
  WEBSITE_WIDGET = 'Website Widget',
  IMPORT = 'Import',
}

export enum AdmissionGroupCancelledBy {
  MEMBER = 'MEMBER',
  RELATIONSHIP = 'RELATIONSHIP',
  TABLELIST = 'TABLELIST',
}

export enum AdmissionGroupSort {
  NAME_ASC = 'name',
  NAME_DSC = '-name',
  DATE_ASC = 'date',
  DATE_DSC = '-date',
}

export enum AdmissionGroupType {
  TABLE = 'TABLE',
  //General Admission
  GUEST_LIST = 'GUEST_LIST',
  TALLY = 'TALLY',
  TICKET = 'TICKET',
}

export enum AdmissionGroupTypeName {
  TABLE = 'Reservation',
  GUEST_LIST = 'Guest List',
  TALLY = 'Tally',
  TICKET = 'Ticket',
}

export enum AdmissionGroupStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  DENIED = 'DENIED',
  //^ these are for approve/deny only - eventually should be it's own collection of AdmissionGroupRequests or something like that
  CONFIRMED = 'CONFIRMED',
  CHECKED_IN_FULL = 'CHECKED_IN_FULL', //legacy support from back when we had CHECKED_IN_PARTIAL and CHECKED_IN_FULL statuses - should only use CHECKED_IN_FULL now

  /**
   * @deprecated use CHECKED_IN_FULL instead
   */
  CHECKED_IN = 'CHECKED_IN_FULL',
  /**
   * @deprecated use CHECKED_IN_FULL instead
   */
  CHECKED_IN_PARTIAL = 'CHECKED_IN_FULL', //legacy support from back when we had CHECKED_IN_PARTIAL and CHECKED_IN_FULL statuses - should only use CHECKED_IN_FULL now
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

export enum AdmissionGroupLeadStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  DENIED = 'DENIED',
  CONFIRMED = 'CONFIRMED',
}

export enum AdmissionGroupStatusName {
  PENDING = 'Pending',
  IN_PROGRESS = 'In Progress',
  DENIED = 'Denied',
  CONFIRMED = 'Expected',
  CHECKED_IN_FULL = 'Checked In',
  CHECKED_IN = 'Checked In',
  CHECKED_IN_PARTIAL = 'Checked In',
  CLOSED = 'Closed',
  CANCELLED = 'Canceled',
}

export enum AdmissionGroupFraudRisk {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export enum AdmissionGroupEvent {
  CREATED = 'ADMISSION_GROUP_CREATED',
  CREATED_IN_BULK = 'ADMISSION_GROUP_CREATED_IN_BULK',
  UPDATED = 'ADMISSION_GROUP_UPDATED',
  RECEIPTS_UPDATED = 'ADMISSION_GROUP_RECEIPTS_UPDATED',
  DATE_UPDATED = 'ADMISSION_GROUP_DATE_UPDATED',
  CANCELLED = 'ADMISSION_GROUP_CANCELLED',
  DELETED = 'ADMISSION_GROUP_DELETED',
  ASSIGNED_TO = 'ADMISSION_GROUP_ASSIGNED_TO',
  CHECKED_IN = 'ADMISSION_GROUP_CHECKED_IN',
}

export enum AdmissionGroupReceiptType {
  PUBLIC = 'PUBLIC',
  INTERNAL = 'INTERNAL',
  INTERNAL_AUTH = 'INTERNAL_AUTH',
}

export enum AdmissionGroupCompType {
  BIRTHDAY = 'BIRTHDAY',
  PROMOTER = 'PROMOTER',
  INDUSTRY = 'INDUSTRY',
  INFLUENCER = 'INFLUENCER',
  ARTIST_OR_TALENT = 'ARTIST_OR_TALENT',
  OWNER = 'OWNER',
  OTHER = 'OTHER',
}

export enum AdmissionGroupCompTypeName {
  BIRTHDAY = 'Birthday',
  PROMOTER = 'Promoter',
  INDUSTRY = 'Industry',
  INFLUENCER = 'Influencer',
  ARTIST_OR_TALENT = 'Artist or Talent',
  OWNER = 'Owner',
  OTHER = 'Other',
}

export enum AdmissionGroupActionType {
  BULK_DELETE = 'BULK_DELETE',
  BULK_CREATE = 'BULK_CREATE',
  BULK_UPDATE = 'BULK_UPDATE',
  CANCEL = 'CANCEL',
  CHECK_IN = 'CHECK_IN',
  SEND_CUSTOMER_CONFIRMATION_CREATE = 'SEND_CUSTOMER_CONFIRMATION_CREATE',
  SEND_CUSTOMER_CONFIRMATION_UPDATE = 'SEND_CUSTOMER_CONFIRMATION_UPDATE',
}

export enum AdmissionGroupFlag {
  BIRTHDAY = 'birthday',
  SIGN_REQUEST = 'sign_request',
  BACHELORETTE = 'bachelorette',
  BACHELOR = 'bachelor',
  CORPORATE_EVENT = 'corporate_event',
  PER_OWNER = 'per_owner',
  PER_MANAGER = 'per_manager',
  NFU = 'nfu',
  PROMOTER = 'promoter',
  PAID_CASH = 'paid_cash',
  PAID_VENMO = 'paid_venmo',
  PAID_CASHAPP = 'paid_cashapp',
  PAID_ZELLE = 'paid_zelle',
  PAID_VIA_WIRE = 'paid_via_wire',
  PAID_VIA_BANK_TRANSFER = 'paid_via_bank_transfer',
  PAID_VIA_CRYPTO = 'paid_via_crypto',
  GIRLS_NIGHT_OUT = 'girls_night_out',
}

export enum AdmissionGroupFlagName {
  birthday = 'Birthday',
  sign_request = 'Sign Request',
  bachelorette = 'Bachelorette',
  bachelor = 'Bachelor',
  corporate_event = 'Corporate Event',
  per_owner = 'Per Owner',
  per_manager = 'Per Manager',
  nfu = 'NFU',
  promoter = 'Promoter',
  paid_cash = 'Paid in Cash',
  paid_venmo = 'Paid on Venmo',
  paid_cashapp = 'Paid on CashApp',
  paid_zelle = 'Paid on Zelle',
  paid_via_wire = 'Paid via Wire',
  paid_via_bank_transfer = 'Paid via Bank Transfer',
  paid_via_crypto = 'Paid via Crypto',
  girls_night_out = 'Girls Night Out',
}

export enum AdmissionGroupError {
  DATE_IS_REQUIRED = 'date is required',
  CUSTOMER_IS_REQUIRED = 'customer is required',
  EMAIL_INVALID = 'email is invalid',
  DATE_MUST_BE_A_DATE = 'date must be a date',
  ORGANIZATION_IS_REQUIRED = 'organization is required',
  VENUE_IS_REQUIRED = 'venue is required',
  VENUE_NOT_FOUND = 'venue not found',
  CUSTOMER_NOT_FOUND = 'customer not found',
  TYPE_IS_REQUIRED = 'type is required',
  TYPE_IS_INVALID = 'type %s is invalid',
  SERVER_NOT_FOUND = 'server not found',
  TABLES_MUST_BE_AN_ARRAY = 'tables must be an array',
  TABLE_ID_IS_REQUIRED = 'table id is required',
  TABLES_ARE_INVALID = 'tables are invalid',
  ADMISSION_GROUP_NOT_FOUND = 'admission group not found',
  ADMISSION_GROUP_POS_TICKET_NOT_FOUND = 'pos ticket not found',
  CANNOT_DELETE_BEFORE_CANCELLING = 'You must cancel before you can delete.',
  FIRST_NAME_MUST_BE_A_STRING = 'firstName must be a string',
  LAST_NAME_MUST_BE_A_STRING = 'lastName must be a string',
  ARRIVAL_TIME_MUST_BE_A_DATE = 'arrivalTime must be a date',
  END_TIME_MUST_BE_A_DATE = 'endTime must be a date',
  GUESTS_EXPECTED_UNISEX_MUST_BE_A_POSITIVE_NUMBER = 'guestsExpectedUnisex must be a positive number',
  GUESTS_EXPECTED_MALE_MUST_BE_A_POSITIVE_NUMBER = 'guestsExpectedMale must be a positive number',
  GUESTS_EXPECTED_FEMALE_MUST_BE_A_POSITIVE_NUMBER = 'guestsExpectedFemale must be a positive number',
  BIRTHDAY_DAY_MUST_BE_A_NUMBER = 'birthdayDay must be a number',
  BIRTHDAY_MONTH_MUST_BE_A_NUMBER = 'birthdayMonth must be a number',
  BIRTHDAY_YEAR_MUST_BE_A_NUMBER = 'birthdayYear must be a number',
  PLATFORM_IS_INVALID = 'platform %s is invalid',
  STATUS_IS_INVALID = 'status %s is invalid',
  SUBSTATUS_IS_INVALID = 'substatus %s is not configured for this venue',
  PAYMENT_STATUS_IS_INVALID = 'paymentStatus %s is invalid',
  RECEIPT_NAME_IS_REQUIRED = 'receipt name is required',
  RECEIPT_SUBTOTAL_MUST_BE_A_NUMBER = 'receipt subtotal must be a number',
  ATTRIBUTION_SOURCE_DOES_NOT_EXIST = 'attributionSource does not exist',
  ATTRIBUTION_TYPE_IS_REQUIRED = 'attributionType is required',
  ATTRIBUTION_TYPE_IS_INVALID = 'attributionType %s is invalid',
  ATTRIBUTION_ID_IS_REQUIRED = 'attributionId is required',
  TABLE_NOT_FOUND = 'table not found',
  EVENT_NOT_FOUND = 'event not found',
  INVENTORY_NOT_FOUND = 'inventory not found',
  EVENT_DATE_DOES_NOT_MATCH_DATE = 'event date does not match date',
  CREATED_BY_TYPE_IS_INVALID = 'createdBy is invalid',
  ORGANIZATION_MEMBER_NOT_FOUND = 'organizationMember not found',
  ORGANIZATION_RELATIONSHIP_NOT_FOUND = 'organizationRelationship not found',
  CANCELLED_BY_TYPE_IS_INVALID = 'cancelledByType %s is invalid',
  CANCELLED_REASON_TYPE_IS_INVALID = 'cancelledReasonType %s is invalid',
  TICKET_ID_IS_REQUIRED = 'ticketNumber is required',
  SERVICE_CHARGES_MUST_BE_A_NUMBER = 'serviceCharges must be a number',
  TAX_MUST_BE_A_NUMBER = 'tax must be a number',
  TIP_MUST_BE_A_NUMBER = 'tip must be a number',
  SUBTOTAL_MUST_BE_A_NUMBER = 'subtotal must be a number',
  TOTAL_MUST_BE_A_NUMBER = 'total must be a number',
  DUE_MUST_BE_A_NUMBER = 'due must be a number',
  PAID_MUST_BE_A_NUMBER = 'paid must be a number',
  DISCOUNTS_MUST_BE_A_NUMBER = 'discounts must be a number',
  INVALID_CHECKIN_STATUS = 'sorry you cannot check in this admission',
  COMP_TYPE_IS_INVALID = 'comp type %s is invalid',
  FLAG_IS_INVALID = 'flag %s must be true or false',
  CANNOT_GENERATE_RECEIPT = 'cannot generate receipt because no credit card was used on this booking',
}
